// removed by extract-text-webpack-plugin
module.exports = {"view":"view__prjxI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/styles.scss
// module id = 2226
// module chunks = 1